import type { Theme } from '@mui/material/styles';

import { getLibraryPageTokens, type LibraryPageTokens } from '../library/getLibraryPageTokens';

export interface ClientsPageTokens extends LibraryPageTokens {
  listItemSelectedBg: string;
  listItemSelectedColor: string;
  listItemHoverBg: string;
}

export const getClientsPageTokens = (theme: Theme): ClientsPageTokens => {
  const pageTokens = getLibraryPageTokens(theme);

  return {
    ...pageTokens,
    listItemSelectedBg: pageTokens.filterPillActiveBg,
    listItemSelectedColor: pageTokens.filterPillActiveColor,
    listItemHoverBg: pageTokens.cardHoverBackground,
  };
};
